<template>
	<div class="main">
		<div class="grzx-left">
			<div class="user-name">
				{{userInfo.name}}
			</div>
			<div class="user-head">
				<img :src="userInfo.headImg ? $imgUrl + userInfo.headImg : '../../../static/user_head.png'" alt="">
			</div>
			<Upload
				class="change-head-button"
				ref="img_ref"
				:action="$baseUrl + '/sys/accessory/uploadFile'"
				:on-success="successUpload"
				:max-size="10240"
				name="uploadFile">
				{{lang == 'zh' ? '修改头像' : 'Change Avatar'}}
			</Upload>
			<!-- <div class="user-level">
				<div class="left">
					<i class="iconfont iconcollection-b"></i>
					<i class="iconfont iconcollection-b"></i>
				</div>
				<div class="right">
					中校
				</div>
			</div> -->
			<div class="user-point">
				{{lang == 'zh' ? '总积分' : 'Total Point'}}：{{userInfo.integral}}
			</div>
			<div class="grzx-box" v-for="(item, index) in leftList" @click="jumpTo(index)" :style="{borderBottom: index == 4 ? '' : '1px solid #C5C5C5', color: index === selectIndex ? '#2D5AC3' : ''}">
				<div>
					<i class="iconfont" :class="item.icon">

					</i>
				</div>
				<div style="margin-left: 10px;">
					{{lang == 'zh' ? item.name : item.en_name}}
				</div>
			</div>
		</div>
		<div class="grzx-right">
			<div class="wdmpyy-top">
				<div style="display: flex; position: absolute; top: 0; left: 20px; z-index: 100;">
					<div style="height: 40px; line-height: 40px; cursor: pointer;" @click="$router.back(-1)">
						<i class="iconfont iconfanhui" style="font-size: 24px;"></i>
					</div>
					<div style="font-size: 12px; margin-left: 10px;">
						{{lang == 'zh' ? '返回列表' : 'Back'}}
					</div>
				</div>

				<div style="font-size: 12px; position: absolute; width: 100%; text-align: center; top: 0; left: 0; z-index: 99;">
					{{ticket_details.orderType == 'TEAM' ? (lang == 'zh' ? '团队预约': 'Team appointment ') : (lang == 'zh' ? '个人预约': 'Personal appointment ')}}{{lang == 'zh' ? '订单详情' : 'order detail'}}
				</div>
			</div>
			<div class="ddxx-details">
				<Row v-if="ticket_details.orderType == 'TEAM'">
					<Col span="16">
						<Row style="margin-top: 20px; font-size: 18px;">
							<Col span="6">
								{{lang == 'zh' ? '订单编号' : 'Order number'}}:
							</Col>
							<Col span="18">
								{{ticket_details.partnerOrderId}}
							</Col>
						</Row>
						<Row style="margin-top: 20px; font-size: 18px; height: 40px; line-height: 40px;">
							<Col span="6">
								{{lang == 'zh' ? '订单状态' : 'Order status'}}:
							</Col>
							<Col span="6">
								<span v-if="ticket_details.ticketStatus == 'FAILED'" style="color: #ed4014;">
									{{lang == 'zh' ? '预约失败' : 'Failure'}}
								</span>
								<span v-else-if="ticket_details.ticketStatus == 'WAIT'">
									{{lang == 'zh' ? '待审核' : 'In review'}}
								</span>
								<span v-else style="color: #19be6b;">
									{{lang == 'zh' ? '预约成功' : 'Success'}}
								</span>
							</Col>
							<Col span="6" v-if="ticket_details.ticketStatus == 'FAILED'">
								<div style="padding: 0 15px; background-color: #1173E1; color: #FFFFFF; text-align: center; cursor: pointer;" @click="toEdit">
									{{lang == 'zh' ? '修改预约' : 'Edit'}}
								</div>

							</Col>
						</Row>
						<Row style="margin-top: 20px; font-size: 18px;" v-if="ticket_details.ticketStatus == 'FAILED'">
							<Col span="6">
								{{lang == 'zh' ? '审核意见' : 'Audit opinion'}}:
							</Col>
							<Col span="18" style="color: #ed4014;">
								{{ticket_details.refuseReason || ''}}
							</Col>
						</Row>

						<Row style="margin-top: 20px; font-size: 18px;">
							<Col span="6">
								{{lang == 'zh' ? '团队名称' : 'Team name'}}:
							</Col>
							<Col span="18">
								{{ticket_details.userOrg.orgName || ''}}
							</Col>
						</Row>
						<Row style="margin-top: 20px; font-size: 18px;">
							<Col span="6">
								{{lang == 'zh' ? '人数' : 'Number'}}:
							</Col>
							<Col span="18">
								{{ticket_details.ticketVisits.length}}
							</Col>
						</Row>
						<Row style="margin-top: 20px; font-size: 18px;">
							<Col span="6">
								{{lang == 'zh' ? '入馆时间' : 'Entry time'}}:
							</Col>
							<Col span="18">
								{{ticket_details.visitDate + '   ' + ticket_details.visitTime}}
							</Col>
						</Row>
						<Row style="margin-top: 20px; font-size: 18px;">
							<Col span="6">
								{{lang == 'zh' ? '联系人员' : 'Contact Person'}}:
							</Col>
							<Col span="18">
								{{ticket_details.liaisonUser}}
							</Col>
						</Row>
						<Row style="margin-top: 20px; font-size: 18px;">
							<Col span="6">
								{{lang == 'zh' ? '联系电话' : 'Phone number'}}:
							</Col>
							<Col span="18">
								{{ticket_details.liaisonPhone}}
							</Col>
						</Row>
					</Col>
					<Col span="8">
						<div class="qrcode" style="display: none" v-if="qrCode">
							<img :src="qrCode" alt="">
						</div>
						<div v-if="qrCode" style="margin-top: 5px; color: #FC4850; font-size: 16px; text-align: center;">
							<div v-if="lang == 'zh'">
								<p>
									请将此页面截屏或拍照保存。
								</p>
								<p>
									届时前往正门西侧安检入馆。
								</p>
								<p>
									请按预约的时段入馆参观，
								</p>
								<p>
									提前或错过预约时段的谢绝入馆。
								</p>
							</div>
							<div v-else>
								<p>
									Please take a screenshot or photo of this page and save it.
								</p>
								<p>
									Then go to the west side of the main gate to enter the security check.
								</p>
								<p>
									Please visit the museum at the appointed time.
								</p>
								<p>
									No admission for those who advance or miss the booking time.
								</p>
							</div>
						</div>
					</Col>
				</Row>
				<Row v-else>
					<Col span="16">
						<Row style="margin-top: 20px; font-size: 18px;">
							<Col span="6">
								{{lang == 'zh' ? '订单编号' : 'Order number'}}:
							</Col>
							<Col span="18">
								{{ticket_details.partnerOrderId}}
							</Col>
						</Row>
						<Row style="margin-top: 20px; font-size: 18px;">
							<Col span="6">
								{{lang == 'zh' ? '订单状态' : 'Order status'}}:
							</Col>
							<Col span="18">
								<span v-if="ticket_details.ticketStatus == 'FAILED'" style="color: #ed4014;">
									{{lang == 'zh' ? '预约失败' : 'Failure'}}
								</span>
								<span v-else style="color: #19be6b;">
									{{lang == 'zh' ? '预约成功' : 'Success'}}
								</span>
							</Col>
						</Row>
						<Row style="margin-top: 20px; font-size: 18px;">
							<Col span="6">
								{{lang == 'zh' ? '姓名' : 'Name'}}:
							</Col>
							<Col span="18">
								{{ticket_details.liaisonUser}}
							</Col>
						</Row>
						<Row style="margin-top: 20px; font-size: 18px;">
							<Col span="6">
								{{lang == 'zh' ? '人数' : 'Number'}}:
							</Col>
							<Col span="18">
								{{ticket_details.ticketVisits.length}}
							</Col>
						</Row>
						<Row style="margin-top: 20px; font-size: 18px;">
							<Col span="6">
								{{lang == 'zh' ? '入馆时间' : 'Entry time'}}:
							</Col>
							<Col span="18">
								{{ticket_details.visitDate + '   ' + ticket_details.visitTime}}
							</Col>
						</Row>
						<Row style="margin-top: 20px; font-size: 18px;">
							<Col span="6">
								{{lang == 'zh' ? '联系电话' : 'Phone number'}}:
							</Col>
							<Col span="18">
								{{ticket_details.liaisonPhone}}
							</Col>
						</Row>
					</Col>
					<Col span="8">
						<div class="qrcode" style="display: none" v-if="qrCode">
							<img :src="qrCode" alt="">
						</div>
						<div style="margin-top: 5px; color: #FC4850; font-size: 16px; text-align: center;" v-if="lang == 'zh'">
							<p>
								请将此页面截屏或拍照保存。
							</p>
							<p>
								届时前往正门西侧安检入馆。
							</p>
							<p>
								请按预约的时段入馆参观，
							</p>
							<p>
								提前或错过预约时段的谢绝入馆。
							</p>
						</div>
						<div style="margin-top: 5px; color: #FC4850; font-size: 16px; text-align: center;" v-else>
							<p>
								Please take a screenshot or photo of this page and save it.
							</p>
							<p>
								Then go to the west side of the main gate to enter the security check.
							</p>
							<p>
								Please visit the museum at the appointed time.
							</p>
							<p>
								No admission for those who advance or miss the booking time.
							</p>
						</div>
					</Col>
				</Row>
			</div>
			<div style="text-align: left; margin: 10px auto; font-size: 18px;" v-if="lang == 'zh'">
				<div>
					1.馆内不提供停车服务，提倡绿色出行。
				</div>
				<div>
					2.请在馆内参观期间，看护好老人、小孩，防止磕碰、意外发生。
				</div>
				<div>
					3.请提前准备本人有效证件、预约二维码、绿色健康码，配合工作人员例行安检。
				</div>
				<div>
					4.其他未尽事宜以海军博物馆官方网站、APP、公众号信息为准。
				</div>
			</div>
			<div style="text-align: left; margin: 10px auto; font-size: 18px;" v-else>
				<div>
					1. There is no parking service in the museum, and green travel is advocated.
				</div>
				<div>
					2. Please take good care of the elderly and children during your visit to the museum to prevent collisions and accidents.
				</div>
				<div>
					3. Please prepare your valid certificate, make an appointment with QR code and green health code in advance, and cooperate with the staff for routine security check.
				</div>
				<div>
					4. Other matters not covered herein shall be subject to the information on the official website, APP and official account of the Navy Museum.
				</div>
			</div>

			<div style="text-align: left; margin: 10px auto;" v-if="lang == 'zh'">
				<div style="margin-top: 20px; color: #686868; font-size: 14px;">
					16：00停止入馆，17：00闭馆。
				</div>
				<div style="margin-top: 2px; color: #686868; font-size: 14px;">
					填写二代身份证的游客可直接凭身份证原件入馆参观。
				</div>
				<div style="margin-top: 2px; color: #686868; font-size: 14px;">
					填写港澳台身份证或护照的游客须持证件原件至售票窗口换取门票后，凭门票入馆参观。
				</div>
			</div>
			<div style="text-align: left; margin: 10px auto;" v-else>
				<div style="margin-top: 20px; color: #686868; font-size: 14px;">
					Admission stops at 16:00 and closes at 17:00.
				</div>
				<div style="margin-top: 2px; color: #686868; font-size: 14px;">
					Visitors who fill in the second-generation ID card can enter the museum directly with the original id card.
				</div>
				<div style="margin-top: 2px; color: #686868; font-size: 14px;">
					Visitors who fill in Hong Kong, Macao and Taiwan ID cards or passports should bring the original id cards to the ticket window to exchange for tickets, and then enter the museum with the tickets.
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				leftList: [
					{
						name: '个人信息',
						en_name: 'Information',
						path: '/grxx',
						icon: 'iconyonghu1'
					},
					{
						name: '我的门票预约',
						en_name: 'Ticket',
						path: '/wdmpyy',
						icon: 'iconmenpiao'
					},
					{
						name: '我的活动预约',
						en_name: 'Activity',
						path: '/wdhdyy',
						icon: 'iconliwu'
					},
					// {
					// 	name: '我的点赞',
					// 	path: '/wddz',
					// 	icon: 'icondianzan'
					// },
					// {
					// 	name: '我的收藏',
					// 	path: '/wdsc',
					// 	icon: 'iconcollection-b'
					// },
				],
				selectIndex: 1,
				userInfo: {

				},
				ticket_details: {
					ticketVisits: []
				},
				qrCode: ''
			}
		},
		computed: {
			lang() {
				return this.$store.state.lang
			}
		},
		mounted() {
			let that = this
			document.body.scrollTop = document.documentElement.scrollTop = 0
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../static/hyzx_top.png'
			that.ticket_details = JSON.parse(that.$http.getStorage('ticket'))
			if(that.ticket_details.partnerCode) {
				that.getOrder(that.ticket_details.partnerCode)
			}
			that.getUserInfo()
		},
		methods: {
			getOrder(partnerCode) {
				// let that = this
				// that.$http.post({
				// 	url: '/api/ticket/ck/createQRCode?partnerCode=' + partnerCode,
				// 	data: {}
				// }).then(res => {
				// 	if(res.code === 'S200') {
				// 		that.qrCode = res.data
				// 	} else {
				// 		that.$Message.error(res.msg)
				// 	}
				// })
			},
			jumpTo(index) {
				let that = this
				if(index === that.selectIndex) {
					return
				}
				that.$router.push(that.leftList[index].path)
			},
			successUpload(res) {
				let that = this
				if(res.code === 'S200') {
					that.$http.post({
						url: '/api/user/ck/updateUser',
						data: {
							id: that.$http.getStorage('userId'),
							headImg: res.data.id
						}
					}).then(ress => {
						if(ress.code === 'S200') {
							that.getUserInfo()
						} else {
							that.$Message.error(ress.msg)
						}
					})
				}
			},
			getUserInfo() {
				let that = this

				that.$http.post({
					url: '/api/user/ck/getUserDetail',
					data: {
						id: that.$http.getStorage('userId')
					}
				}).then(res => {
					if(res.code === 'S200') {
						if(res.data) {
							that.userInfo = res.data
						} else {
							that.userInfo = {}
						}
					} else if(res.code === 'F001') {
						that.$router.push('login')
					}
				})
			},
			toEdit() {
				let that = this
				that.$router.push({
					path: '/mpyy',
					query: {
						jump_type: 'edit'
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.main {
		width: 80%;
		margin: 30px 10% 150px;
		display: flex;
		justify-content: space-between;
		.grzx-left {
			width: 15%;
			padding: 10px 20px;
			background-color: #F6F8FF;
			height: 550px;
			.user-name {
				color: #264EA7;
				font-size: 16px;
				text-align: center;
				overflow: hidden;
				text-overflow: ellipsis;
				height: 30px;
				line-height: 30px;
			}
			.user-head {
				width: 75px;
				height: 75px;
				margin: 10px auto;
				border-radius: 50%;
				img {
					width: 100%;
					height: 100%;
					border-radius: 50%;
				}
			}
			.change-head-button {
				width: 115px;
				height: 25px;
				line-height: 25px;
				margin: 0 auto;
				text-align: center;
				background-color: #264EA7;
				border-radius: 10px;
				color: #FFFFFF;
				font-size: 9px;
				cursor: pointer;
			}
			.user-level {
				width: 70%;
				margin: 10px auto;
				display: flex;
				justify-content: center;
				height: 25px;
				.left {
					border-top: 3px solid #D3D3D3;
					border-bottom: 3px solid #D3D3D3;
					color: #D3D3D3;
					display: flex;
					i {
						font-size: 14px;
					}
				}
				.right {
					background-color: #EDD68E;
					color: #0E40DF;
					font-size: 12px;
					line-height: 25px;
					padding: 0 10px;
				}
			}
			.user-point {
				color: #264EA7;
				font-size: 12px;
				height: 30px;
				line-height: 30px;
			}
			.grzx-box {
				height: 60px;
				line-height: 60px;
				text-align: left;
				display: flex;
				font-size: 13px;
				color: #686868;
				cursor: pointer;
				.iconfont {
					font-size: 16px;
					color: #2D5AC3;
				}
			}
		}
		.grzx-right {
			width: 80%;
			.wdmpyy-top {
				height: 40px;
				line-height: 40px;
				padding: 0 20px;
				background-color: #264EA7;
				color: #FFFFFF;
				position: relative;
			}
			.ddxx-details {
				width: 100%;
				padding: 20px 40px;
				color: #686868;
				font-size: 11px;
				text-align: left;
				border-bottom: 1px solid #ccc;
			}
		}
	}
	.qrcode {
		text-align: center;
		img {
			width: 200px;
			height: 200px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/user_center/wdmpyy_details.vue